import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import Reveal from "../components/Reveal";

export default function BlogList() {
  const { lang, t } = useLang();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/blog").then((res) => {
      setPosts(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <main data-testid="blog-list-page" className="pt-32 sm:pt-40 pb-32 min-h-screen">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="grid grid-cols-12 gap-y-8 gap-x-6 mb-20">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{t.blog.eyebrow}</span>
          </Reveal>
          <Reveal as="h1" className="col-span-12 lg:col-span-9 h-section-lg text-olive">
            {t.blog.title}
          </Reveal>
        </div>

        {loading ? (
          <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-olive-soft">…</div>
        ) : posts.length === 0 ? (
          <div className="font-serif italic text-3xl text-olive-soft">{t.blog.empty}</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-16 gap-x-10">
            {posts.map((p, i) => (
              <Reveal key={p.slug} delay={i * 60} data-testid={`blog-card-${p.slug}`}>
                <Link to={`/blog/${p.slug}`} className="group block">
                  {p.cover_image && (
                    <div className="aspect-[4/5] overflow-hidden mb-6 bg-ivory-pure">
                      <img
                        src={p.cover_image}
                        alt={p[`title_${lang}`] || p.title_es}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                    </div>
                  )}
                  <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta mb-3">
                    {(p[`category_${lang}`] || p.category_es)}
                  </div>
                  <h2 className="font-display text-3xl text-olive leading-tight mb-4 group-hover:text-terracotta transition-colors">
                    {(p[`title_${lang}`] || p.title_es)}
                  </h2>
                  <p className="text-olive-soft leading-relaxed mb-4">
                    {(p[`excerpt_${lang}`] || p.excerpt_es)}
                  </p>
                  <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-olive link-underline">{t.blog.readMore} →</span>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
